export default __webpack_public_path__ + "static/media/vguard.e02f9210.gif";